import { defineMessages } from 'react-intl';

export default defineMessages({
  goodResponseLabel: {
    id: 'frontbucket.repository.autoreviewFeedback.goodResponseLabel',
    description:
      'Label shown on Autoreview comment for the good response icon.',
    defaultMessage: 'Helpful',
  },
  badResponseLabel: {
    id: 'frontbucket.repository.autoreviewFeedback.badResponseLabel',
    description: 'Label shown on Autoreview comment for the bad response icon.',
    defaultMessage: 'Not helpful',
  },
  textAreaLabel: {
    id: 'frontbucket.repository.autoreviewFeedback.textAreaLabel',
    description:
      'Label shown on text-area for collecting info from Bad Autoreview responses',
    defaultMessage: 'Can you describe why this answer was unhelpful?',
  },
  thankYouMessage: {
    id: 'frontbucket.repository.autoreviewFeedback.thankYouMessage',
    description:
      'Message shown after submitting feedback on Autoreview comment',
    defaultMessage: 'Thank you for your feedback!',
  },
  howDidAutoreviewDoMessage: {
    id: 'frontbucket.repository.autoreviewFeedback.howDidAutoreviewDoMessage',
    description:
      'Bold text that appears underneath an Autoreview comment asking for feedback',
    defaultMessage: 'How did Autoreview do?',
  },
  rateAutoreviewCommentMessage: {
    id: 'frontbucket.repository.autoreviewFeedback.rateAutoreviewCommentMessage',
    description: 'Text that appears next the bold text asking for feedback',
    defaultMessage: 'Rate this comment to make Autoreview more useful',
  },
  contentQualityMayVary: {
    id: 'frontbucket.repository.autoreviewFeedback.contentQualityMayVary',
    description: 'Appears in the footer on Autoreview comments',
    defaultMessage: 'Content quality may vary',
  },
  beta: {
    id: 'frontbucket.repository.autoreviewFeedback.beta',
    description: 'Text for beta lozenge indicating this is Beta functionality',
    defaultMessage: 'Beta',
  },
});
